import React from 'react';
import AppApi from "../../api/app";
import toast from 'react-hot-toast';
import gallery from "../../api/gallery";
import * as Yup from "yup";
import { useSelector, useDispatch } from 'react-redux';
import Actions from '../../store/actions';

import { ErrorMessage, Field, Form, Formik } from "formik";
let validationSchema = Yup.object({
   // websiteLogo: Yup.string().required("websiteLogo  is required."),
   websiteTitle: Yup.string().required("websiteTitle is required."),
   currencySymbol: Yup.string().required("currencySymbol is required."),
});

function UpdateSetting({ data }) {
   let setting = data.setting;
   let dispatch = useDispatch();
   const uploadFile = async (file) => {
      try {
         if (file) {
            if (gallery?.allowedPictureFormats?.includes(file.type)) {
               let apiData = {
                  fileName: file?.name,
                  fileType: file.type,
                  fileSize: file.size,
                  useType: "LOGO"
               }
               let res = await gallery.s3UrlMake(apiData, "LOGO");
               console.log(res.data);
               if (res?.data?.data?.url) {
                  let tostId = toast.loading("Uploading....")
                  let response = await gallery.s3UploadLoader(res.data?.data?.url, file, percent => {
                     console.log(percent);
                     // setFilePercentageLoader(percent)
                  });
                  toast.success("Uploaded successfully.", { id: tostId });
                  let filePath = await gallery.getOnlyFileUrl(response);
                  return filePath
               } else {
                  return ""
               }
            } else {
               toast.error("This file is not allowed to upload.");
               return ""
            }
         }

      } catch (error) {
         console.log(error.message)
         return ""
      }
   }
   return (
      <>
         <Formik
            initialValues={{
               websiteLogo: setting?.websiteLogo || "",
               faviconIcon: setting?.faviconIcon || "",
               deliveryType: setting?.deliveryType || "LOCATIONS_BASED",//LOCATIONS_BASED
               fixedDeliveryCostStatus: setting?.fixedDeliveryCostStatus || false,
               texChargingType: setting?.texChargingType || "FREE",
               texPercentage: setting?.texPercentage || 0,
               websiteTitle: setting?.websiteTitle || "",
               websiteDescription: setting?.websiteDescription || "",
               metaTitle: setting?.metaTitle || "",
               metaDescription: setting?.metaDescription || "",
               currencySymbol: setting?.currencySymbol || "",
               contactNumber: setting?.contactNumber || "",
               contactEmail: setting?.contactEmail || "",
               // primaryColor: setting?.primaryColor || "",
               // secondaryColor: setting?.secondaryColor || "",
            }}
            validationSchema={validationSchema}
            onSubmit={async (values, { setSubmitting, resetForm }) => {
               setSubmitting(true);
               try {
                  let res = "";
                  if (data?._id) {
                     res = await AppApi.updateSettings(values);
                  }
                  if (res?.data?.error == false) {
                     toast.success(res?.data?.msg);
                     dispatch(Actions.addProfile({ ...data, setting: res?.data?.data }));
                  }
                  setSubmitting(false);
               } catch (error) {
                  console.log(error.message);
                  setSubmitting(false);
               }
            }}
         >
            {({ isSubmitting, values, errors, setFieldValue }) => (
               <Form>
                  {/* {JSON.stringify(values)} */}
                  <div className="d-flex gap-3 justify-space-even">
                     <div className="text-center border">
                        {values.faviconIcon && (
                           <img src={values.faviconIcon} alt="" style={{ width: "100%", maxWidth: "300px" }} className='mb-4' />
                        )}
                        <div className="border p-1 text-center pointer"
                           onClick={() => {
                              document.getElementById("faviconIcon").click();
                           }}
                        >
                           <i className='fas fa-upload me-1'></i>Upload favicon Icon
                           <input
                              type="file"
                              id="faviconIcon"
                              onChange={async (e) => {
                                 if (e.target.value) {
                                    let file = e.currentTarget.files[0]
                                    if (file.type.split("/")[0] === "image") {
                                       let filePath = await uploadFile(file);
                                       if (filePath) {
                                          setFieldValue("faviconIcon", filePath)
                                       }
                                    } else {
                                       toast.error("This file is not allowed to upload.");
                                    }
                                 } else {
                                    toast.error("No file found to upload.");
                                 }
                              }}
                              className="d-none"
                           />
                        </div>
                     </div>
                     <div className="text-center border">
                        {values.websiteLogo && (
                           <img src={values.websiteLogo} alt="" style={{ width: "100%", maxWidth: "300px" }} className='mb-4' />
                        )}
                        <div className="border p-1 text-center pointer"
                           onClick={() => {
                              document.getElementById("websiteLogo").click();
                           }}
                        >
                           <i className='fas fa-upload me-1'></i>Upload logo
                           <input
                              type="file"
                              id="websiteLogo"
                              onChange={async (e) => {
                                 if (e.target.value) {
                                    let file = e.currentTarget.files[0]
                                    if (file.type.split("/")[0] === "image") {
                                       let filePath = await uploadFile(file);
                                       if (filePath) {
                                          setFieldValue("websiteLogo", filePath)
                                       }
                                    } else {
                                       toast.error("This file is not allowed to upload.");
                                    }
                                 } else {
                                    toast.error("No file found to upload.");
                                 }
                              }}
                              className="d-none"
                           />
                        </div>
                     </div>
                  </div>
                  <ErrorMessage component="small" className='text-danger' name="websiteLogo" />
                  <div className=" form mt-1">
                     <div className="form-group flex-grow-1">
                        <label>Website Title</label>
                        <Field
                           name="websiteTitle"
                           type="text"
                           className="form-control rounded"
                           placeholder="Website title"
                        />
                        <ErrorMessage component="small" className='text-danger' name="websiteTitle" />
                     </div>
                  </div>
                  <div className="form-group mt-1">
                     <label>Website Description</label>
                     <Field
                        name="websiteDescription"
                        type="text"
                        className="form-control rounded"
                        placeholder="location cost"
                     />
                     <ErrorMessage component="small" className='text-danger' name="websiteDescription" />
                  </div>
                  <div className="form-group mt-1">
                     <label>Meta Title</label>
                     <Field
                        name="metaTitle"
                        type="text"
                        className="form-control rounded"
                        placeholder="location cost"
                     />
                     <ErrorMessage component="small" className='text-danger' name="metaTitle" />
                  </div>
                  <div className="form-group mt-1">
                     <label>Meta Description</label>
                     <Field
                        name="metaDescription"
                        type="text"
                        className="form-control rounded"
                        placeholder="location cost"
                     />
                     <ErrorMessage component="small" className='text-danger' name="metaDescription" />
                  </div>
                  <div className="form-group mt-1">
                     <label>Contact Number</label>
                     <Field
                        name="contactNumber"
                        type="text"
                        className="form-control rounded"
                        placeholder="location cost"
                     />
                     <ErrorMessage component="small" className='text-danger' name="contactNumber" />
                  </div>
                  <div className="form-group mt-1">
                     <label>Contact Email</label>
                     <Field
                        name="contactEmail"
                        type="text"
                        className="form-control rounded"
                        placeholder="location cost"
                     />
                     <ErrorMessage component="small" className='text-danger' name="contactEmail" />
                  </div>
                  <div className="form-group mt-1">
                     <label>Currency Symbol</label>
                     <select className='form-control'
                        value={values?.currencySymbol}
                        onChange={(event) => {
                           setFieldValue("currencySymbol", event.target.value)
                        }}
                     >
                        <option value="">Select Symbol</option>
                        <option value="$" >$</option>
                        <option value="RS" >RS</option>
                     </select>
                     <ErrorMessage component="small" className='text-danger' name="currencySymbol" />
                  </div>
                  {/* <div className="form-group mt-1">
                     <label>primaryColor</label>
                     <Field
                        name="primaryColor"
                        type="color"
                        className="form-control rounded"
                        placeholder="location cost"
                     />
                     <ErrorMessage component="small" className='text-danger' name="primaryColor" />
                  </div> */}
                  {/* <div className="form-group mt-1">
                     <label>secondaryColor</label>
                     <Field
                        name="secondaryColor"
                        type="color"
                        className="form-control rounded"
                        placeholder="location cost"
                     />
                     <ErrorMessage component="small" className='text-danger' name="secondaryColor" />
                  </div> */}
                  <div className="p-0 mt-5 text-left col-sm-12">
                     <div className="mb-1 form-group d-flex justify-content-end">
                        <button type="submit" disabled={isSubmitting} className=" btn rounded-0 btn-dark">{isSubmitting ? "Loading..." : data?._id ? "Update" : "Update"}</button>
                     </div>
                  </div>
               </Form>
            )}
         </Formik >
      </>
   )
}

export default UpdateSetting